import { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import ReviewSignContracts from "./ReviewSignContracts";
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box padding={'20px 0px 0px 0px'}>
          <Typography sx={{
            fontFamily: "Outfit"
          }}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ContentManagement = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Typography sx={{ fontSize: { xs: "20px", md: "28px" }, fontWeight: "500", paddingBottom: '10px', fontFamily: "Outfit" }}>
          Content Management
        </Typography>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="content management tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            "& .MuiTab-root": {
              fontSize: { xs: "12px", sm: "14px", md: "16px" },
            },
          }}
        >
          <Tab label="Review & Sign Contracts" {...a11yProps(0)} sx={{
            textTransform: 'capitalize',
            fontFamily: "Outfit"
          }} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <ReviewSignContracts />
        </TabPanel>
      </Box>
    </>
  );
};

export default ContentManagement;
